const ConstantsStrings = {
  SET_USER_DATA: "set_user_data",
  SET_LOGIN_TIMESTAMP: "set_login_timestamp",
  ACCESS_TOKEN: "access_token",
  REFRESH_TOKEN: "refresh_token",
  LOGOUT_IN_PROGRESS: "logout_in_progress",
  OPEN_USERS_DIALOG: "open_users_dialog",
  CLOSE_USERS_DIALOG: "close_users_dialog",
};

export default ConstantsStrings;
